/**
 * 테마·자막 크기 컨트롤 — §14 다크 기본 + 자막 토큰 스케일.
 *
 * 크기는 프리셋 순환이 아니라 **+/− 스테퍼**다(§14): 회의실마다 필요한
 * 크기가 다른데 프리셋 셋으로는 맞출 수 없었다.
 */

import { Button } from '@cupia/ui/button'
import { Moon, Sun } from 'lucide-react'
import { useTheme } from '../lib/use-presentation'
import { useCaptionScale } from '../lib/use-caption-scale'
import { CaptionSizeStepper } from './caption-size-stepper'

export function ThemeControls({
  showPresentation = false,
}: {
  /** 자막 크기 스테퍼를 함께 그린다(자막 화면에서만) */
  showPresentation?: boolean
}): React.ReactElement {
  const { dark, toggle } = useTheme()
  const scale = useCaptionScale()

  return (
    <div className="flex items-center gap-1">
      {showPresentation && (
        <CaptionSizeStepper
          step={scale.step}
          onIncrease={scale.increase}
          onDecrease={scale.decrease}
          canIncrease={scale.canIncrease}
          canDecrease={scale.canDecrease}
        />
      )}
      <Button
        variant="ghost"
        size="sm"
        onClick={toggle}
        aria-label={dark ? '라이트 모드로' : '다크 모드로'}
        title={dark ? '라이트 모드로' : '다크 모드로'}
      >
        {dark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
      </Button>
    </div>
  )
}
